const SoldOutProductMessage = () => (
  <div className="price-tag-soldout-message">
    <p>Indisponível</p>
  </div>
)

export default SoldOutProductMessage
